var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('relayDetailWin',_vm._b({ref:"detailDialog",attrs:{"detailObj":_vm.detailObj,"deviceProperty":_vm.deviceProperty,"detailNetObj":_vm.netObj,"deviceType":_vm.deviceType}},'relayDetailWin',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }